<template>
  <div style="overflow:hidden;"  class="mainbox">
    <div class="leftbox">
      <div class="leftboxmain" id="leftboxmain">
        <div class="backlist" @click="$router.go(-1)">
            <span>
              <Icon type="ios-arrow-back" />返回列表
            </span>
          </div>
        <Anchor show-ink :offset-top="160" :scroll-offset="30">          
          <AnchorLink v-for="(item,index) in leftcategoryList" :key="index" :href="'#wordid-'+item.id" :title="item.name" />
          <!-- <AnchorLink href="#b-word-bangongruanjian" title="办公软件/应用" />
          <AnchorLink href="#b-word-bama" title="宝妈/宝宝" />
          <AnchorLink href="#b-word-biji" title="笔记应用/软件" />
          <AnchorLink href="#b-word-banjia" title="搬家/运货" />
          <AnchorLink href="#b-word-bitebi" title="比特币/币圈" /> -->
        </Anchor>
      </div>
    </div>
    <div class="rightbox">
      <div class="rightmainbox">
        <div class="fenleibiaoti">
          <h3>B</h3>
          <h2>分类标签导航</h2>
        </div>
        <div class="fenleimain">
          <div class="indexcell" :id="'#wordid-'+item.category.id" v-for="(item,index) in tswebsiteList" :key="index">
            <table>
              <thead @click="gotolabellist(item.category.id)">
                <tr>
                  <td>
                    <em><Icon type="ios-arrow-forward" /></em>
                    <span>
                      <b></b>
                      <i>{{item.category.name}}</i>
                    </span>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li v-for="(itemss,indexs) in item.websiteList" :key="indexs">
                        <webcell :categorydata="itemss"></webcell>
                      </li>
                     
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          
        </div>
      </div>
    </div>

    <div class="footerbox"></div>

    <div class="addwebbox">
      <addweb></addweb>
    </div>
    <BackTop :bottom="200" :right="25"></BackTop>
  </div>
</template>

<script>
import addweb from "../publish/addweb";
import webcell from "../publish/webcell";
// import { getlistByCategoryInitial } from "../../api/api";

export default {
  components: { addweb,webcell },
  data() {
    return {
      blogo01: require("@/assets/images/b-icon_001.jpg"),
      blogo02: require("@/assets/images/b-icon_002.jpg"),
      blogo03: require("@/assets/images/b-icon_003.jpg"),
      blogo04: require("@/assets/images/b-icon_004.jpg"),
      blogo05: require("@/assets/images/b-icon_005.jpg"),
      anlismlogo: require("@/assets/images/alsmlogo.gif"),
      leftcategoryList:[],
      tswebsiteList:[]
    };
  },
  created(){
    //document.querySelector('.ivu-anchor-ink-ball').style.top=8+'px';
    window.scrollTo(0,0);
    let initial = this.$route.query.initial;
    getlistByCategoryInitial(initial).then(res=>{
      if(res.code==200){
        this.leftcategoryList = res.data.categoryList;
        this.tswebsiteList = res.data.websiteList;
      }
      console.log('getlistByCategoryInitial',res)
    })
    
  },
  mounted(){
    document.querySelector('.ivu-anchor-ink-ball').style.top=8+'px';
    this.$Loading.finish();
  },
  methods:{
    gotolabeldetails(){
      this.$router.push({
        name:'labeldetails'
      })
    },
    gotolabellist(id){
      this.$router.push({
        name:'labellist',
        query:{
          id
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.mainbox{ padding-top: 50px;}
html,
body {
  height: 100%;
}
.leftbox {
  height: 100%;
  float: left;
  width: 230px;

  .leftboxmain {
    padding-left: 50px;
    padding-top: 30px;
    font-size: 15px;

    .backlist {
      padding-top: 10px;
      margin-top: 10px;
      padding-bottom: 20px; position: fixed;top:90px; cursor: pointer;
      span {
        border: 1px solid #f3f3f3;
        padding: 10px 20px;
        border-radius: 30px;
        font-size: 13px;
        line-height: 15px;
        i {
          padding-right: 10px;
          font-size: 16px;
          color: #999;
        }
      }
    }

    .zimubox {
      background: #f8f8f8;
      width: 40px;
      padding-top: 10px;
      padding-bottom: 10px;
      border-radius: 30px;
      font-size: 13px;
      margin-top: 15px;
    }
  }
}
.rightbox {
  width: 100%;

  .rightmainbox {
    padding-left: 250px;min-height:680px;

    ul.meitianul li {
      float: left;
      width: 22%;
      max-width: 355px;
      margin-right: 20px;
    }

    .dailyanlibox {
      overflow: hidden;
      h2 {
        font-size: 18px;
        padding-top: 30px;
        padding-bottom: 20px;
        font-weight: normal;
      }
      .dailylistbox {
        overflow: hidden;
        .alimgbox {
          img {
            max-width: 355px;
            max-height: 214px;
            width: 100%;
          }
        }
        .alimgname {
          padding-top: 8px;
          dl {
            dt {
              float: left;
              min-width: 50px;
              img {
                margin-left: 8px;
                margin-top: 8px;
              }
            }

            dd {
              float: left;
              width: 80%;
              h5 {
                font-size: 15px;
                font-weight: normal;
                color: #333;
              }
              p {
                color: #999;
                overflow: hidden;
                text-overflow: ellipsis;
                /*-webkit-text-overflow:ellipsis;*/
                white-space: nowrap;
              }
            }

            @media screen and (max-width: 1380px) {
              /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
              dd {
                float: left;
                width: 70%;
                h5 {
                  font-size: 15px;
                  font-weight: normal;
                  color: #333;
                }
                p {
                  color: #999;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  /*-webkit-text-overflow:ellipsis;*/
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
    }

    .fenleibiaoti {
      h3 {
        font-size: 25px;
        padding-top: 35px;
      }
      h2 {
        font-size: 18px;
        padding-top: 15px;
        padding-bottom: 25px;
        font-weight: normal;
      }
    }

    .fenleimain {
      box-shadow: 0 0 3.5px #ddd;
      max-width: 1480px;
      width: 93.5%;

      .indexcell {
        table {
          width: 100%;
          border-collapse: collapse;
          thead {
            background: #f6f8f9;
            line-height: 60px;cursor: pointer;
            em{ float:right; color: #ccc; font-size: 18px; padding-right: 20px;}
            b {
              display: inline-block;
              height: 15px;
              width: 3px;
              background: #505050;
            }
            span {
              font-size: 18px;
              margin-right: 10px;
              i {
                padding-left: 20px;
                font-size: 17px;
              }
            }
          }
          tbody {
            background: #fff;
            tr td {
              ul li {
                width: 25%;
                float: left; position: relative;
                height: 95px;
                border: 1px solid #f3f3f9;
                border-left: none;
                border-top: none;
                cursor: pointer;
                span{
                  position: absolute;right: 0; top:0px; background: #fff; padding: 5px;
                  i{ float: left; padding-left:5px; padding-right: 5px;color: #999;}
                  img{float: left; margin-top:2px;}
                }
                dl {
                  padding-top: 28px;
                  dt {
                    float: left;
                    width: 50px;
                    padding-left: 15px;
                    padding-top: 5px;
                  }
                  dd {
             
                    padding-left: 55px;
                    
                    h5 {
                      font-size: 15px;
                      font-weight: normal;
                      color: #333;
                    }
                    p {
                      color: #999;
                      font-size: 12px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      /*-webkit-text-overflow:ellipsis;*/
                      white-space: nowrap;
                    }
                  }
                }
              }
              ul li:last-child {
              }
              ul li:first-child {
                border-left: none;
              }

              ul li:hover{ box-shadow: 0 0 8px #ddd;}

              @media screen and (max-width: 1420px) {
                /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
                ul li {
                  width: 25%;
                }
              }
            }
          }
        }
      }
    }

    @media screen and (min-width: 1470px) and (max-width: 1840px) {
      .fenleimain {
        width: 92.5%;
      }
    }

    @media screen and (max-width: 1220px) {
      /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
      .fenleimain {
        width: 94%;
      }
    }
  }
}

.newword {
  display: inline-block;
  margin-left: 5px;
  width: 20px;
  line-height: 20px;
  background: #11be04;
  color: #fff;
  text-align: center;
}
.hotword {
  display: inline-block;
  margin-left: 5px;
  width: 20px;
  line-height: 20px;
  background: #ff0030;
  color: #fff;
  text-align: center;
}

.footerbox {
  height: 60px;
}

.addwebbox {
  right: 30px;
  position: fixed;
  top: 38%;
}
@media screen and (max-width: 1300px) {  
  .addwebbox {
    right: 15px;
    position: fixed;
    top: 38%;
  }
}

>>> .ivu-anchor-ink:before {
  background-color: #fff;
}

>>> .ivu-anchor-link-active>.ivu-anchor-link-title{color: #ffa200;}
>>> .ivu-anchor-link >.ivu-anchor-link-title:hover{color: #ffa200;}

>>> .ivu-anchor-ink-ball {
  width: 18px;
  border-radius: 0;
  background-color: #ffa200;
  border: 0 #fff solid;
  height: 3px;
  margin-top: 3px;
}

</style>




// WEBPACK FOOTER //
// src/components/pages/biaoqianlist.vue